import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Redirect from './Redirect'
import PostForm from './PostForm'
import clients from 'redux/clients'

import { push } from 'connected-react-router'

class RedirectContainer extends Component {
  constructor (props) {
    super(props)

    const {
      match: {
        params: { vendorId }
      }
    } = this.props

    this.vendorId = vendorId

    const {
      cloudloyalty: { client }
    } = clients

    this.client = client

    this.state = {
      errorAlert: null,
      postProperties: null
    }

    this.closeError = this.closeError.bind(this)
  }

  componentDidMount () {
    this.secondFactorValidation()
  }

  closeError () {
    this.setState({ errorAlert: null })
  }

  throwError (title, description) {
    this.setState({
      errorAlert: {
        title: title,
        description: description,
        closeError: () => this.closeError()
      }
    })
  }

  secondFactorValidation () {
    this.client
      .get(
        `/v1/secondfactorauth/sendtoken?tokenType=sms&authorizationCode=&supplierId=${
          this.vendorId
        }&supplierValidation=false`
      )
      .then(result => {
        this.handleTokenResult(result)
      })
      .catch(() =>
        this.throwError(
          'Problema ao redirecionar',
          'Ocorreu um problema ao tentar redirecioná-lo.'
        )
      )
  }

  handleTokenResult ({ data }) {
    if (data.onBoardingRequired || !data.authorized) {
      this.throwError(
        'Problema ao redirecionar',
        'Ocorreu um problema ao tentar redirecioná-lo. '
      )
      return
    }

    this.handleRedirect(data)
  }

  handleRedirect ({ redirectUrl }) {
    this.client
      .get(
        `/v1/configurations/catalog/${this.props.catalogId}/vendor/${
          this.vendorId
        }/client/${this.props.clientId}/parameter/isPost/value`
      )
      .then(({ data }) => {
        if (data && data === true) {
          this.redirectToForm(redirectUrl)
        } else {
          this.redirectToStore(redirectUrl)
        }
      })
      .catch(() =>
        this.throwError(
          'Problema ao redirecionar',
          'Ocorreu um problema ao tentar redirecioná-lo.'
        )
      )
  }

  redirectToStore (urlReturn) {
    let {
      location: { search }
    } = this.props

    if (search && search.includes('?')) urlReturn += `&${search.split('?')[1]}`

    if (!urlReturn.includes('http') || urlReturn.includes('#')) {
      this.props.internalRedirect('/vendor?vendor=' + this.vendorId)
    } else {
      window.location = urlReturn.replace(/^"(.+(?="$))"$/, '$1')
    }
  }

  redirectToForm (urlReturn) {
    let parameters = urlReturn.split('?')
    let postData = parameters[1].split('&')

    this.setState({
      postProperties: {
        action: parameters[0],
        parameters: postData
      }
    })
  }

  render () {
    return (
      <Fragment>
        <Redirect {...this.state} />
        {this.state.postProperties ? (
          <PostForm
            action={this.state.postProperties.action}
            token={this.props.token}
            parameters={this.state.postProperties.parameters}
          />
        ) : (
          ''
        )}
      </Fragment>
    )
  }
}

RedirectContainer.propTypes = {
  match: PropTypes.object.isRequired,
  catalogId: PropTypes.number.isRequired,
  clientId: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  internalRedirect: PropTypes.func,
  token: PropTypes.string
}

const mapStateToProps = ({
  participant: { catalogId, clientId },
  oidc: { user }
}) => ({
  catalogId,
  clientId,
  token: `${user['token_type']} ${user['access_token']}`
})

const mapDispatchToProps = dispatch => ({
  internalRedirect: path => dispatch(push(path))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RedirectContainer)



// WEBPACK FOOTER //
// ./src/features/Redirect/RedirectContainer.js